module.exports = __webpack_public_path__ + "img/MIGRATION.e6dd308b.svg";